<template>
  <router-view />
</template>

<style lang="less">
@import "@/assets/styles/colors.less";
@import "@/assets/fonts.css";

html,
body {
  margin: 0px !important;
  padding: 0px !important;
}

#app {
  font-family: Monserrat, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-x: hidden;
  background: @text_1;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
